/**
 * Created by maofaming on 2017/4/27.
 */
import q from 'q';
import sensitivityCheck from '@/module/SensitivityCheck';
import auditConfig from '@/module/AuditConfig';
import EditText from '@/common/widget/EditText';
import PictureCover from '@/common/widget/Picture';
import QuRequest from '@/core/QuRequest';
import CommentRadio from '@/common/widget/CommentRadio.vue';
import TitleParty from '@/common/widget/TitleParty.vue';
const quRequest = new QuRequest();

export default {
    created () {
        this.filter = this.$queryFilter();
        this.$updateRouter(this.filter);
    },
    components: {
        PictureCover,
        EditText,
        CommentRadio,
        TitleParty
    },
    data () {
        return {
            commentStatus: auditConfig.commentStatus,
            commentType: auditConfig.commentType,
            isTitleParty: false,
            hotTagList: [],
            stat: {}
        };
    },
    computed: {
        auditUserInfo () {
            return this.$store.getters.getUser;
        },
        isRevieDrop () {
            if (this.audit.status === 1 && this.audit.is_recommend == 2) {
                return true;
            }
            return false;
        }
    },
    methods: {
        updateBoxSize () {
            // 计算窗口大小，设置审核页面滚动条高度
            let viewNode = this.$el.querySelector('.audit-view-box');
            let wHeight = document.body.clientHeight;
            let wWidth = document.body.clientWidth;
            let viewRect = viewNode.getBoundingClientRect();
            if (wWidth * 0.75 > viewRect.width) {
                document.addEventListener('scroll', this.scrollEvent);
                viewNode.style.cssText = 'min-height:' + wHeight + 'px';
            }
        },

        scrollEvent (event) {
            // 监听滚动带伤
            let scrollNode = document.scrollingElement || document.body;
            let top = scrollNode ? scrollNode.scrollTop : 0;
            if (top >= 68) {
                this.isScrollDefault = false;
                if (!this.isScrollFixed) {
                    let fixedNode = document.body.querySelector('.audit-control-box');
                    let size = window.getComputedStyle(fixedNode);
                    fixedNode.style.cssText =
                        'position: fixed;' +
                        'right: ' +
                        size.paddingRight +
                        ';' +
                        'width:' +
                        size.width +
                        ';' +
                        'bottom: -10px;' +
                        'top: 36px';
                    this.isScrollFixed = true;
                }
            } else {
                this.isScrollFixed = false;
                if (!this.isScrollDefault) {
                    let fixedNode = document.body.querySelector('.audit-control-box');
                    fixedNode.style.cssText = '';
                    this.isScrollDefault = true;
                }
            }
        },
        removal (tags) {
            this.clearTags = this.formatTags(tags).split(',');
        },

        checkTitleParty (parm = false) {
            return quRequest
                .send(this.quApi.checkTitleParty, {
                    content_id: parm || this.$data.filter.id
                })
                .then(d => {
                    if (d.code != 0) {
                        throw new Error(`标题党检查失败: ${d.message || '未知原因'}`);
                    }
                    d = d.data;
                    this.$data.isTitleParty = !('success' in d);
                });
        },
        checkVideoTitleParty (data) {
            return quRequest
                .send(this.quApi.checkVideoTitleParty, {
                    video_id: this.$data.filter.id,
                    title: data || ''
                })
                .then(d => {
                    if (d.code != 0) {
                        throw new Error(`标题党检查失败: ${d.message || '未知原因'}`);
                    }
                    d = d.data;
                    this.$data.isTitleParty = !('success' in d);
                });
        },

        formatTags (tag) {
            // 格式化内容标签
            let tags = sensitivityCheck.clearTag(tag); // 清洗标签中的被标记的敏感词span
            return tags.replace(/，/g, ',');
        },
        formatContent (content) {
            // 清洗内容中的被标记的敏感词span
            return sensitivityCheck.clearTag(content);
        },
        backAudit () {
            let param = {
                product_key: 'midu',
                app_key: 'story',
                content_id: this.filter.content_id
            };
            quRequest
                .send(quRequest.Apis.audit.contentreviewaudit.exitaudit, param)
                .then(res => {
                    this.$router.push({ name: 'UserArticleReview' });
                })
                .catch(res => {
                    this.$message.success('退出审核失败，请重试！');
                })
                .fin(() => {});
        },
        // 跳转审核记录
        backAuditHistory () {
            let that = this;
            this.$message({
                message: '已退出审核',
                type: 'success',
                duration: 1000,
                onClose () {
                    that.$router.push({ name: 'AuditHistory' });
                }
            });
        },
        toTop () {
            // 返回到页面顶部，在获取到下一篇审核内容时需求
            window.pageYOffset = 0;
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        },
        getQueryId () {
            // 获取url参数中带来的id
            return (this.$route.query && this.$route.query.id) || '';
        },
        modifyContent (id) {
            // 修改文章状态
            if (id && this.audit.hasOwnProperty('closeShare')) {
                // 如果文章存在
                let modify = {
                    id: id
                };
                if (this.audit.closeShare === '1') {
                    modify['share_type'] = 3;
                }
                if (this.audit.type) {
                    modify['type'] = this.audit.type;
                }

                return quRequest.send(quRequest.Apis.qukan.content.modifyContent, modify);
            } else {
                return q.resolve();
            }
        },
        clearNotify () {
            // 清除页面的notify 提示
            let notify;
            while ((notify = this.notifyTipList.shift())) {
                notify.close();
            }
        },

        sendAudit (formData, isVideo = false, review = false) {
            // 提交内容审核
            let that = this;
            this.disabled = true;
            let endTime = new Date();
            let lackMark = review ? formData.lackMark : false;
            !!review && delete formData.lackMark;
            this.clearNotify();
            delete formData['life'];
            quRequest
                .send(this.quApi.audit, formData)
                .then(res => {
                    // 提交文章
                    if (lackMark) {
                        that.markLackOfFactor(lackMark);
                    }
                    // 标注统计结束时间的接口
                    //    this.reportAuditAction(reportConfig.ACTION.END, endTime)
                    // 测试标注取消文章这个接口所以取消调用
                    // if (formData.publish_id > 0 || res.data && res.data.publish_id > 0) {
                    //     return this.modifyContent(formData.publish_id > 0 ? formData.publish_id : res.data.publish_id).then(shareRes => { // 修改文章状态
                    //         this.showAuditMsg(formData,isVideo)
                    //     })
                    // } else {
                    //     this.showAuditMsg(formData,isVideo)
                    // }
                    this.showAuditMsg(formData, isVideo);
                })
                .catch(res => {
                    that.errorMsg(res);
                })
                .fin(() => {
                    // that.disabled = false
                });
        },
        showAuditMsg (formData, isVideo) {
            //  显示内容审核结果
            let that = this;
            let messageType = !this.getQueryId() ? '进入下一条' : '返回列表页面';
            let messageTip = '成功, ' + messageType;
            that.disabled = true;
            if (!isVideo) {
                switch (formData.status) {
                case 2:
                    messageTip = '审核成功,' + messageType;
                    break;
                case 3:
                    messageTip = '驳回成功,' + messageType;
                    break;
                }
            } else {
                switch (formData.status) {
                case 1:
                    messageTip = '审核成功,' + messageType;
                    break;
                case 2:
                    messageTip = '驳回成功,' + messageType;
                    break;
                }
            }
            this.$message({
                message: messageTip,
                type: 'success',
                duration: 1000,
                onClose () {
                    that.submitSuccess();
                }
            });
            if (formData.refresh) {
                setTimeout(() => {
                    this.$router.go(0);
                }, 500);
            }
            this.toTop();
        },
        modifyClass (formData, isVideo = false, review) {
            // 修改分类
            if (
                this.detailData.changeClass.category &&
                this.detailData.changeClass.category !=
                    ((this.detailData.classifications && this.detailData.classifications[0].id) ||
                        this.detailData.category)
            ) {
                quRequest
                    .send(this.quApi.changeClassification, this.detailData.changeClass)
                    .then(res => {
                        this.sendAudit(formData, isVideo, review);
                    })
                    .catch(res => {
                        this.$message({
                            message: res.message || '分类变更失败，请重新提交',
                            type: 'error'
                        });
                    });
            } else {
                this.sendAudit(formData, isVideo, review);
            }
        },
        submitSuccess () {
            // 提交成功
            let id = this.getQueryId();
            if (id) {
                // 有id ,表示从搜索结果中进度审核
                this.$router.go(-1);
            } else {
                // 没有id, 表示直接进入审核
                this.resetAudit();
                this.getView();
            }
            // that.disabled = false;
        },
        auditTimeout () {
            // 显示审核超时提示
            let that = this;
            let title = '提示, 审核超时';
            let msg = '你离开的太久了系统自动退出审核,是否继续审核';
            this.$confirm(msg, title, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.getView();
                })
                .catch(() => {
                    that.backAudit();
                });
        },
        markLackOfFactor (param = false) {
            // 根据参数对文章不足因素进行标记
            if (!param) return false;
            quRequest
                .send(this.quApi.markLackFactor, { ...param })
                .then(v => {
                    // 标注成功
                })
                .catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                });
        },
        nativeView (param) {
            return new Promise((resolve, reject) => {
                // this.loading = true
                // this.disabled = true
                let that = this;

                quRequest
                    .send(quRequest.Apis.audit.contentreviewaudit.view, param)
                    .then(res => {
                        if (res.data && Object.keys(res.data).length) {
                            let data = res.data;
                            if (!data.id) {
                                data.id = data.contentId;
                            }
                            this.updateAudit(data.id);
                            data.title = this.htmlEncode(data.title);
                            data.tag = this.htmlEncode(data.tag);
                            if (this.reportAnalysisData) {
                                this.reportAnalysisData.content_id = data.id;
                                this.reportAnalysisData.title = data.title;
                                // this.reportAuditAction(reportConfig.ACTION.START, startTime)
                            }
                            resolve(data);
                        } else {
                            this.$message({
                                message: '没有未审核内容',
                                type: 'error',
                                duration: 500,
                                onClose () {
                                    that.$router.push({ name: that.auditPathName });
                                }
                            });
                            reject(res);
                        }
                    })
                    .catch(res => {
                        this.errorMsg(res);
                        reject(res);
                    })
                    .fin(() => {
                        this.loading = false;
                    })
                    .done();
            });
        },
        recallTip (id = false) {
            if (!id) return false;
            quRequest
                .send(quRequest.Apis.qupost.complain.getReason, { content_id: id })
                .then(v => {
                    if (v.data && v.data.length > 0) {
                        this.notifyTipList.push(
                            this.$notify({
                                title: '提示',
                                message: `本内容因${v.data}被投诉`,
                                duration: 0
                            })
                        );
                    }
                })
                .catch(error => {
                    this.$message({ type: 'error', message: `${error.message}` });
                });
        },
        getHotTagList (id = false) {
            if (!id) return;
            quRequest
                .send(quRequest.Apis.qukan.contentReview.getHotTags, { contentId: id })
                .then(v => {
                    this.hotTagList = v.data.info || [];
                })
                .catch(error => {
                    this.$message({
                        type: 'error',
                        message: `${error.message}`
                    });
                });
        },
        errorMsg (res) {
            // 错误消息提示，返回-400表示审核过期
            let that = this;
            if (res.code == -400) {
                this.auditTimeout(); // code == -400 表示审核过期
            } else if (res.message && res.message.indexOf('已审核') > -1) {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            } else {
                that.$message({
                    message: res.message || '未知原因操作失败',
                    type: 'error'
                });
            }
        },
        updateAudit (id) {
            // 更新filter.id 提交文章时需要带上id
            if (id && id !== this.filter.id) {
                this.filter.id = id;
            }
        },
        markCoverQualify (allList = [], passList = []) {
            // 封面图片，allList表示所有图片，passList表示质量通过的图片，对没有通过的封面需要在页面中标记出来
            let newArray = [];
            for (let i = 0, len = allList.length; i < len; i++) {
                let k = 0;
                let size = passList.length;
                while (k < size) {
                    if (allList[i] === passList[k]) {
                        break;
                    }
                    k++;
                }
                newArray.push({
                    url: allList[i],
                    quality: k === size ? 'low' : 'pass'
                });
            }
            return newArray;
        },
        toArray (str) {
            // 将字符串转为数组
            return str.split(',');
        },
        reportAuditAction (action, date) {
            if (this.reportAnalysisData) {
                date = date || new Date();
                let report = Object.assign({}, this.reportAnalysisData);
                report.action = action;
                report.op_id = this.auditUserInfo.id;
                report.time_node = Math.floor(date.getTime() / 1000);
                quRequest.send(quRequest.Apis.analysis.collect.timeLine.process, {
                    data: JSON.stringify(report)
                });
            }
        },
        openImage (urls) {
            window.open(urls, '_blank');
        },
        getrejectreason (appName, reasonType) {
            let that = this;
            // 此处新增负反馈需求，更换接口--聂元培
            quRequest.send(that.quApi.getrejectreason, { appName, reasonType }).then(res => {
                if (reasonType == 1) {
                    that.status.passAuditReasons = res.data.list || [];
                } else {
                    that.status.defaultAuditReasons = res.data.list || [];
                }
            });
        },
        getTagName (tags) {
            // 获取标签
            let that = this;
            let nameArr =
                (tags &&
                    tags
                        .map(item => {
                            return item.name;
                        })
                        .join(',')) ||
                [];
            that.parentDynamicTags = nameArr.length ? nameArr.split(',') : [];
            that.clearTags = that.formatTags(that.parentDynamicTags).split(',');
        },
        commentReCall () {
            let detailData = this.detailData;
            let auditData = this.audit;
            if (auditData.is_recommend == 1 && detailData.queueType == '2') {
                let isClickCommentBtn = localStorage.getItem('commentReCall');
                let commentObj = JSON.parse(isClickCommentBtn) || {};
                if (!commentObj.hasOwnProperty(detailData.contentId)) {
                    this.$message({
                        message: '评论召回文章，请查看用户评论后提交'
                    });
                    return true;
                }
            }
        },
        // 降权信息
        reduceReasonHandler (previewReason, punishGrad, rejectReasonIds) {
            this.reduceReason = {
                reason: previewReason,
                punishGrade: punishGrad,
                rejectReasonIds: rejectReasonIds
                // discard: discard
            };
        },
        // 降权提示
        reduceReasonTipHandle () {
            if (
                this.isRevieDrop &&
                (!('reason' in this.reduceReason) || this.reduceReason.reason.length < 1) // 原因
            ) {
                // check选择原因
                this.$message({
                    message: '降权必须填写原因',
                    type: 'error'
                });
                return true;
            }
        }
    },
    mounted () {
        this.isScrollFixed = false;
        this.isScrollDefault = false;
        this.updateBoxSize();
    },
    beforeDestroy () {
        this.isScrollFixed = false;
        this.isScrollDefault = false;
        document.removeEventListener('scroll', this.scrollEvent);
    }
};
